import PropTypes from 'prop-types';
import React from 'react';
export default class MonthDropdownOptions extends React.Component {
    renderOptions = ()=>this.props.monthNames.map((month, i)=>/*#__PURE__*/ React.createElement("div", {
                className: this.props.month === i ? 'react-datepicker__month-option --selected_month' : 'react-datepicker__month-option',
                key: month,
                ref: month,
                onClick: this.onChange.bind(this, i)
            }, this.props.month === i ? /*#__PURE__*/ React.createElement("span", {
                className: "react-datepicker__month-option--selected"
            }, "✓") : '', month));
    onChange = (month)=>this.props.onChange(month);
    handleClickOutside = ()=>this.props.onCancel();
    render() {
        return /*#__PURE__*/ React.createElement("div", {
            className: "react-datepicker__month-dropdown"
        }, this.renderOptions());
    }
}
MonthDropdownOptions.propTypes = {
    month: PropTypes.number.isRequired,
    monthNames: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    onCancel: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired
};
